import { Module } from 'wrapper6'
import { hasClass } from '../utils/_class-handlers'
import { mttAjax } from 'utils/_mtt_ajax'
// eslint-disable-next-line no-redeclare
/* global jQuery */
const $ = jQuery

export default class Cart extends Module {
  handleCartHtml (html) {
    const miniCartHtml = new DOMParser().parseFromString(html, 'text/html')
    this.miniCart.innerHTML = miniCartHtml.querySelector('.menu-mini-cart').innerHTML
  }

  handleCartCount (count) {
    const CART_ITEM = document.querySelector('.mtt-header__main-nav-icon-link.mtt-open-cart .count')
    if (CART_ITEM) {
      CART_ITEM.innerHTML = count
      CART_ITEM.classList.remove('hidden')
    }
  }
  ready (app) {
    const MENU_MINI_CART = document.querySelector('.menu-mini-cart')
    const HEADER = document.getElementById('main_header')
    const VARIATIONS = document.querySelectorAll('.col-text .variation')

    let OPEN = document.querySelector('.mtt-open-cart')
    let CLOSE = document.querySelector('.menu-meni-cart-close')

    this.miniCart = MENU_MINI_CART;
    this.OVERLAY = document.getElementById('cart-overlay')

    this.handleMiniCartState(CLOSE, OPEN, HEADER, MENU_MINI_CART)

    if (MENU_MINI_CART) {
      MENU_MINI_CART.addEventListener('DOMSubtreeModified', () => {
        OPEN = MENU_MINI_CART.querySelector('.mtt-open-cart')
        CLOSE = MENU_MINI_CART.querySelector('.menu-meni-cart-close')

        this.handleMiniCartState(CLOSE, OPEN, HEADER, MENU_MINI_CART)
      })
      mttAjax('update_cart', {action:'update_cart'}, (response)=>{
        if (typeof response !== 'object' || response === null) return console.warn('Response is not a object!')
        this.handleCartHtml(response.data.mini_cart_html)
        this.handleCartCount(response.data.cart_count)
      })
      document.addEventListener('keydown', (event) => {

        if (event.key === 'Escape') {
          //if esc key was not pressed in combination with ctrl or alt or shift
          const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
          if (isNotCombinedKey) {
            this.closeCart(HEADER, MENU_MINI_CART)
          }
        }
      });
    }

    $(document).on('click', '.col-text .variation .variation-value, .col-text .variation .attribute', function () {
      const hasOpen = $(this).parent().parent().parent().hasClass('open')
      $('.col-text .variation.open').removeClass('open')
      if (hasOpen) {
        $(this).parent().parent().parent().removeClass('open')
      } else {
        $(this).parent().parent().parent().addClass('open')
      }
    })

    $(document).mouseup(function (e) {
      const container = $('.col-text .variation.open')

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open')
      }
    })
    if (MENU_MINI_CART.querySelector('#mtt-amount-per-meter-field') !== null && MENU_MINI_CART.querySelector('#mtt-amount-per-meter-field').length > 0) {
      this.setupPerMeterField()
    }
  }

  handleMiniCartState (CLOSE, OPEN, HEADER, MENU_MINI_CART) {
    if (CLOSE) {
      CLOSE.addEventListener('click', () => {
        this.closeCart(HEADER, MENU_MINI_CART)
      })
    }
    if (OPEN) {
      OPEN.addEventListener('click', () => {
        this.openCart(HEADER, MENU_MINI_CART)
      })
    }
    this.OVERLAY.addEventListener('click', () => {
        this.closeCart(HEADER, MENU_MINI_CART)
    })
  }

  openCart(HEADER, MENU_MINI_CART) {
    if(MENU_MINI_CART.classList.contains('closed')) {
      this.OVERLAY.classList.add('show')
      MENU_MINI_CART.classList.remove('closed')
      document.querySelector('body').classList.add('mini-cart-open')
      document.querySelector('html').classList.add('mini-cart-open')
    }
  }

  closeCart(HEADER, MENU_MINI_CART) {
    if(!MENU_MINI_CART.classList.contains('closed')) {
      this.OVERLAY.classList.remove('show')
      MENU_MINI_CART.classList.add('closed')
      document.querySelector('body').classList.remove('mini-cart-open')
      document.querySelector('html').classList.remove('mini-cart-open')
      $('.col-text .variation.open').removeClass('open')
    }
  }

  setupPerMeterField () {
    const that = this
    jQuery('#mtt-amount-per-meter-field').on('keyup', function () {
      const defaultPerMeter = jQuery('#mtt-amount-per-meter-field').attr('data-per-meter')
      const val = jQuery(this).val()
      that.updateCartQuantityField(Math.ceil(val * defaultPerMeter))
    })
  }

  updateCartQuantityField (quantity) {
    jQuery('.cart input[name=quantity]').val(quantity)
  }
}
